import { useEffect, useState } from 'react';
import { useAuth } from '@/hooks/auth.hooks';
import { canSeeDocPage } from './access';

let docsPromise: Promise<typeof import('.')> | undefined;
const loadDocs = () => {
  docsPromise ??= import('.');
  return docsPromise;
};

/**
 * Whether the logged in user can see a documentation page, for components
 * outside of the documentation (help buttons): the pages are loaded lazily.
 * Undefined while unknown.
 */
export const useDocPageVisible = (slug?: string) => {
  const { primaryRole, isAuthReady } = useAuth();
  const [visible, setVisible] = useState<boolean>();

  useEffect(() => {
    if (!slug || !isAuthReady) {
      setVisible(slug ? undefined : false);
      return undefined;
    }
    let cancelled = false;
    loadDocs().then((docs) => {
      if (!cancelled) {
        setVisible(canSeeDocPage(docs.getDocPage(slug), primaryRole));
      }
    });
    return () => {
      cancelled = true;
    };
  }, [slug, primaryRole, isAuthReady]);

  return visible;
};
